import React from 'react';

import { EuiNotificationBadge } from '../../../../src/components/badge/notification_badge';

export default () => <EuiNotificationBadge>3</EuiNotificationBadge>;
